import { getCurrentBreakpoint, isMobileDisplay } from '../deviceDetection/deviceDetection';

/**
 * Attaches a debounced event listener for the 'resize' event on the window object.
 * When the 'resize' event is triggered, it calls the debounced versions of
 * `getCurrentBreakpoint` and `isMobileDisplay` functions.
 *
 * The debouncing mechanism ensures that the functions are not called too frequently
 * during resizing, preventing performance issues.
 *
 * @function
 * @returns {Function} A cleanup function to remove the event listener when no longer needed.
 */
export const handleResize = ( callbackFn, ...args ) => {
  const getInflectionValues = () => {
    const breakpoint = getCurrentBreakpoint();
    const isMobile = isMobileDisplay();
    return {
      breakpoint,
      isMobile
    };
  };
  const handleResizeFunctions = () => {
    const inflection = getInflectionValues();
    if( typeof callbackFn === 'function' ){
      callbackFn( inflection, ...args );
    }
    else {
      getInflectionValues();
    }
  };

  window.addEventListener( 'resize', handleResizeFunctions );

  return () => {
    window.removeEventListener( 'resize', handleResizeFunctions );
  };
};
